export default __webpack_public_path__ + "static/media/app-store-panel-3.334e6c53.png";